import { Button, Menu, MenuItem, Stack } from '@mui/material'
import useStyles from './styles'
import { useRef, useState } from 'react'
import { ExtraSmallButton } from '../../../custom'
import { LineTypes } from '../../drawingTools/drawing.interface'
import Line from '../../../../assets/icons/drawingTools/Line'
import DashedLine from '../../../../assets/icons/drawingTools/dashedLine'
import DottedLine from '../../../../assets/icons/drawingTools/dottedLine'

export type LineTypeSelectorProps = {
    value: LineTypes,
    onChange: (value: LineTypes) => void
    compact?: boolean
}

const LineTypeSelector: React.FC<LineTypeSelectorProps> = ({ value, compact = false, onChange }) => {
    const { classes, cx } = useStyles()
    const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null)

    const ref = useRef<HTMLDivElement>(null)

    let displayComponent = <Button className={classes.container}
                                   onClick={() => setAnchorEl(ref.current)}>{value}</Button>

    if (compact) {
        displayComponent = (
            <ExtraSmallButton size={'small'} onClick={() => setAnchorEl(ref.current)}>
                {value === 'normal' ? <Line /> : value === 'dotted' ? <DottedLine /> : <DashedLine />}
            </ExtraSmallButton>
        )
    }


    return <div ref={ref} style={{ display: 'flex', justifyContent: 'center' }}>
        {displayComponent}
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            autoFocus={true}
            onClose={() => setAnchorEl(null)}
        >
            <MenuItem selected={value === 'normal'} onClick={() => {
                onChange('normal')
                setAnchorEl(null)
            }}><Stack direction={'row'} gap={1}>
                <Line />
                Normal
            </Stack></MenuItem>
            <MenuItem selected={value === 'dashed'} onClick={() => {
                onChange('dashed')
                setAnchorEl(null)
            }}><Stack direction={'row'} gap={1}>
                <DashedLine />
                Dashed
            </Stack></MenuItem>
            <MenuItem selected={value === 'dotted'} onClick={() => {
                onChange('dotted')
                setAnchorEl(null)
            }}><Stack direction={'row'} gap={1}>
                <DottedLine />
                Dotted
            </Stack></MenuItem>
        </Menu>
    </div>
}

export default LineTypeSelector

